import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_BASE } from '../../config/env';
import { exportToExcel } from '../../utils/exportToExcel';

export default function ComplaintModule({ activeFilter,activeModule, sdate, edate }) {
  const [stationRows, setStationRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    console.log(" complaint ........  called ");
    loadStationData();
  }, [sdate]);

  async function loadStationData() {
    console.log("inside load complaint ")
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${API_BASE}/complaint`, {
        params: {
          sdate: sdate,
          edate: edate
        }
      });
      console.log("complaint resoponse ")
      if ( res.data.result.length > 0) {
        setStationRows(res.data.result);
        // console.log("res.data.stationRows ",res.data.stationRows);
      }
    } catch (e) {
      console.warn('Using default station reference data:', e.message);
    } finally {
      setLoading(false);
    }
  }


  // Highlight classes based on selected dropdown options (activeFilter)
  const getHighlightClass = (colName) => {
    if (!activeFilter) return '';
    const nameMap = {
      totalps: 'ps',
      totalliu: 'liu',
      totaldcrb: 'dcrb',
      totaldcp: 'dcp',
    };
    return nameMap[activeFilter] === colName ? 'highlight-column' : '';
  };

  function handleExcelExport() {
    const headers = ['Sr.No.', 'Police Station', 'Received', 'Pending', 'Finished'];
    const data = stationRows.map((r, i) => [
      i + 1,
      r.station_name,
      r.request_count || 0,
      r.pending_count || 0,
      r.finished || 0,
    ]);
    const titleLabel = (activeModule?.charAt(0).toUpperCase() + activeModule?.slice(1)) || 'Complaint';
    const fmtD = (d) => (d ? d.split('-').reverse().join('-') : '');
    const dateRange = (sdate || edate)
      ? `Date From: ${fmtD(sdate) || 'All'}    To: ${fmtD(edate) || 'All'}`
      : '';
    exportToExcel({
      title: `${titleLabel} Dashboard`,
      dateRange,
      headers,
      data,
      fileName: `${titleLabel}_Dashboard`,
      sheetName: `${titleLabel} Dashboard`,
    });
  }

  return (
  
    <div className="module-container card-upgrade" style={{ padding: '20px' }}>
      {/* Satyapan Station-Wise Verification Table */}
      <div className="table-wrapper image-styled-table-wrapper">
        <table className="image-styled-table">
          <thead>
            <tr>
              <th colSpan="5" style={{ padding: 0, border: 'none', background: 'transparent' }}>
                <div className="table-header-title" style={{ margin: 0, padding: '10px 12px' }}>
                  <span style={{ fontSize: '16px', fontWeight: 700, color: '#1e293b' }}>
                    {activeModule?.charAt(0).toUpperCase() + activeModule?.slice(1)} Dashboard
                  </span>
                  <button
                    className="btn-excel-export"
                    onClick={handleExcelExport}
                    title="Download Excel"
                  >
                    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8.5 18l-2-3h1.2l1.3 2 1.3-2H11.5l-2 3 2.2 3H10.3l-1.3-2-1.3 2H6.3l2.2-3zm5 3v-6h1v5h2v1h-3z"/>
                    </svg>
                    Excel
                  </button>
                </div>
              </th>
            </tr>
           
            <tr>
              <th>Sr.No.</th>
              <th>Police Station</th>
              <th className={getHighlightClass('all')}>Received</th>
              <th className={getHighlightClass('remain')}>Pending</th>
              <th className={getHighlightClass('ps')}>Fineshed</th>
             

            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr><td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>लोड हो रहा है...</td></tr>
            )}
            {error && (
              <tr><td colSpan="9" style={{ textAlign: 'center', color: 'red' }}>{error}</td></tr>
            )}
            {!loading && stationRows.map((r, i) => (
              <tr key={i} className={i % 2 === 1 ? 'alt-row' : ''}>
                <td>{i + 1}</td>
                <td style={{ fontWeight: '600' }}>{r.station_name }</td>
                <td className={getHighlightClass('all')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=all&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.request_count || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('remain')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=remain&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.pending_count  || 0}
                  </Link>
                </td>
                <td className={getHighlightClass('ps')}>
                  <Link to={`/characters?type=${activeModule}&sdate=${sdate}&edate=${edate}&loc=ps&ps=${encodeURIComponent(r.pre_station_code || r.pre_station_name || '')}`}>
                    {r.finished  || 0}
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
